/**
 * Geography-oriented message path utils
 */

import { CanonicalDataType } from "./MessagePathRecord";

export type LatitudeDataType =
  | CanonicalDataType.LatDegFloat
  | CanonicalDataType.LatDegInt
  | CanonicalDataType.Number;

export type LongitudeDataType =
  | CanonicalDataType.LonDegFloat
  | CanonicalDataType.LonDegInt
  | CanonicalDataType.Number;

export function isLatitudeType(
  dataType: CanonicalDataType,
): dataType is LatitudeDataType {
  return (
    dataType === CanonicalDataType.LatDegFloat ||
    dataType === CanonicalDataType.LatDegInt ||
    dataType === CanonicalDataType.Number
  );
}

export function isLongitudeType(
  dataType: CanonicalDataType,
): dataType is LongitudeDataType {
  return (
    dataType === CanonicalDataType.LonDegFloat ||
    dataType === CanonicalDataType.LonDegInt ||
    dataType === CanonicalDataType.Number
  );
}

export function getCorrespondingGeoType(
  initialType: CanonicalDataType,
): CanonicalDataType[] {
  switch (initialType) {
    case CanonicalDataType.LatDegFloat:
      return [CanonicalDataType.LonDegFloat, CanonicalDataType.Number];
    case CanonicalDataType.LonDegFloat:
      return [CanonicalDataType.LatDegFloat, CanonicalDataType.Number];
    case CanonicalDataType.LatDegInt:
      return [CanonicalDataType.LonDegInt, CanonicalDataType.Number];
    case CanonicalDataType.LonDegInt:
      return [CanonicalDataType.LatDegInt, CanonicalDataType.Number];
    case CanonicalDataType.Number:
      return [
        CanonicalDataType.Number,
        CanonicalDataType.LatDegFloat,
        CanonicalDataType.LonDegFloat,
        CanonicalDataType.LatDegInt,
        CanonicalDataType.LonDegInt,
      ];
    default:
      throw new Error("Unsupported canonical data type");
  }
}
